export default "/assets/website/images/facebook.png?d814a3cc76b7d6aa6d55e3a71aaf6ef7";